import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// eslint-disable-next-line no-restricted-imports
import {
    useGetMergedJobSeekerQuery,
    useLazyGetMergedJobSeekerQuery,
} from '@/features/jobseekers/api/index.js'
import {
    jobseekerSelector,
    resetJobseeker,
    setDistributedAt,
    updateJobseekerDetail,
    setJobSeekerWithTicket,
} from '@/stores/jobseeker.js'

/**
 * @param {string} sfId
 * @returns {import('@reduxjs/toolkit/query/react').TypedUseQueryStateResult<any>}
 */
export const useGetMergedJobseekerQuery = useGetMergedJobSeekerQuery

/**
 * @param {string} sfId
 * @returns {[
 *     (sfId: string) => any,
 *     import('@reduxjs/toolkit/query/react').TypedUseQueryStateResult<any>
 * ]}
 */
export const useLazyGetMergedJobseekerQuery = useLazyGetMergedJobSeekerQuery

export const useClearJobSeeker = () => {
    const dispatch = useDispatch()
    return useCallback(() => {
        return dispatch(resetJobseeker())
    }, [dispatch])
}

export const useSelectJobSeeker = () => {
    const dispatch = useDispatch()
    return useCallback(
        async (data) => {        
            const { detail, distributedAt } = data
            await dispatch(setJobSeekerWithTicket({ detail, distributedAt }))
        },
        [dispatch]
    )
}

export const useSelectedJobSeeker = () => {
    const {
        // isConfirmed,
        // sfId,
        detail,
    } = useSelector(jobseekerSelector)
    return detail
}
